<template lang="pug">
- path = "@/assets/images/epilogue/"
.epilogue
  a.logo.fade-in(:data-is-show="appearOrder >= 3" :href="linkYonimo" target="_blank")
    span 世にも奇妙な物語
  .face.fade-in(:data-is-show="appearOrder >= 1" @animationend="addAppearOrder" :data-chara-type="resultImageType")
    img(:src="resultSrc" alt="")
  .result-text-wrapper.fade-in(:data-is-show="appearOrder >= 2" @animationend="shiftText")
      .result-text(ref="text" v-text="currentText" @animationend="shiftText")
  .bottom-content.fade-in(:data-is-show="appearOrder >= 3")
    .shindan-wrapper
      p.shindan__headline
        span あなた
        span の
        span 鐔ｭЖ_診断
      .shindan
        h2.shindan__title: span 診断結果
        p.shindan__pre {{ userName }}さんの来世は…
        p.shindan__content {{ resultName }}<br />でしょう。
    .share
      a.share__button--twitter(:href="twitterUrl" target="_blank" @click="sendShareEvent('twitter')")
        img(src=`${path}btn_twitter@2x.png` alt="ツイートする")
      a.share__button--facebook(:href="facebookUrl" target="_blank" @click="sendShareEvent('facebook')")
        img(src=`${path}btn_fb@2x.png` alt="シェアする")
      a.share__button--line(:href="lineUrl" target="_blank" @click="sendShareEvent('line')")
        img(src=`${path}btn_line@2x.png` alt="ラインで送る")
    .advertisement
      p.advertisement__headline
        img(src=`${path}ttl_yonimo@2x.png` alt="世にも奇妙な物語 18秋の特別編")
      p.advertisement__date
        img(src=`${path}txt_date@2x.png` alt="11月10日(土) よる9時 放送")
    router-link.again(:to="{ name: 'top' }" @click.native="sendRestartEvent")
      img(src=`${path}btn_again@2x.png` alt="もう一度診断する")
</template>

<style lang="scss" scoped>
.epilogue {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: #1e1e1f;
  color: #fff;
  line-height: 2;
  overflow: hidden;
  img {
    pointer-events: none;
  }
}

.logo {
  position: absolute;
  top: 20px;
  right: 9px;
  display: block;
  width: (170px / 2);
  height: (118px / 2);
  background-image: image-url("/epilogue/yonimo-logo@2x.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: (170px / 2) (118px / 2);
  span {
    display: none;
  }
}

.face {
  img {
    width: 100%;
  }
  &[data-chara-type="face"] {
    width: (422px / 2);
    height: (649px / 2);
    margin-bottom: (20px / 2);
    padding-top: (162px / 2);
  }
  &[data-chara-type="picture"] {
    width: (640px / 2);
    height: (492px / 2);
    margin-bottom: (80px / 2);
    padding-top: (202px / 2);
  }
}

.result-text-wrapper {
  height: (204px / 2);
  margin-bottom: (140px / 2);
}

.result-text {
  white-space: pre;
  font-size: (34px / 2);
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.9);
  @include font-mincho;
  opacity: 0;
}

.bottom-content {
  width: 100%;
  padding-bottom: 140px;
  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    width: 100%;
    height: (482px / 2);
    background-image: linear-gradient(
      0deg,
      rgb(80, 81, 70) 0%,
      rgba(30, 30, 31, 0) 100%
    );
  }
}

.shindan-wrapper {
  position: relative;
  margin-bottom: (80px / 2);
  padding-bottom: (80px / 2);
  background-color: #fff;
  &::after {
    $w: (750px / 2);
    $h: (770px / 2);
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: ($w + 5px);
    height: $h;
    background-image: image-url("/epilogue/result_bg_spot@2x.png");
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
  }
}

.shindan__headline {
  width: 10em;
  margin-left: 30px;
  padding: 40px 0 15px;
  @include font-mincho;
  -webkit-font-smoothing: never;
  font-weight: 900;
  font-size: 60px;
  line-height: 1;
  transform-origin: 115px 0;
  transform: scaleX(0.3);
  span {
    display: inline-block;
    color: #000;
    &:nth-child(2) {
      transform: rotate(180deg) translateY(-30%);
    }
    &:nth-child(3) {
      transform: translateY(-35%);
    }
  }
}

.shindan {
  width: (610px / 2);
  margin: auto;
  padding-bottom: 35px;
  overflow: hidden;
  background-color: #9ff;
  text-align: center;
  font-size: 20px;
  line-height: (46 / 40);
}

.shindan__title {
  width: (610px / 2);
  height: (58px / 2);
  margin: 30px 0 25px;
  background-image: image-url("shindan-title@2x.png");
  background-size: contain;
  background-repeat: no-repeat;
  span {
    display: none;
  }
}

.shindan__pre {
  color: #000;
  font-weight: bold;
  margin-bottom: 1em;
}

.shindan__content {
  color: #000;
  font-style: italic;
}

.share {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: (244px /2);
}

.share__button {
  display: block;
  width: (316px / 2);
  height: (90px / 2);
  margin-bottom: (20px / 2);
  & > img {
    width: 100%;
  }
}

.share__button--twitter {
  margin-right: (10px / 2);
}

.share__button--twitter,
.share__button--facebook,
.share__button--line {
  @extend .share__button;
}

.advertisement {
  margin-bottom: (240px / 2);
}

.advertisement__headline {
  display: block;
  width: (520px / 2);
  height: (444px / 2);
  margin: 0 auto (56px / 2);
  & > img {
    width: 100%;
  }
}

.advertisement__date {
  width: (506px / 2);
  height: (166px / 2);
  margin: 0 auto;
  & > img {
    width: 100%;
  }
}

.again {
  position: relative;
  display: block;
  width: (518px / 2);
  height: (138px / 2);
  margin: 0 auto;
  & > img {
    width: 100%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s ease-in;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.fade-in {
  display: none;
  opacity: 0;
  &[data-is-show="true"] {
    display: block;
    animation: fadeIn 1s ease-in forwards;
  }
}
</style>

<script>
import { TimelineMax, Power1 } from "gsap";
import { mapState, mapGetters } from "vuex";

import commonConfig from "@/mixin/commonConfig";
import {
  createTwitterIntent,
  createFacebookIntent,
  createLineIntent
} from "@/js/libs/shareHelper";
import { AUDIO_SRC } from "@/const/config";
import { audioApi } from "@/js/soundManager";

export default {
  name: "epilogue",
  data() {
    return {
      textState: null,
      appearOrder: 0,
      currentText: ""
    };
  },
  computed: {
    ...mapState(["userName"]),
    ...mapGetters(["resultName", "resultData"]),
	shareText() {
	  return `${this.userName}の来世は
${this.resultName}
に決まりました。


#あなたの鐔ｭЖ_診断 #世にも奇妙な物語

`;
	},
    twitterUrl() {
      return createTwitterIntent({
        url: this.shareUrl,
        text: this.shareText
      });
    },
    facebookUrl() {
      return createFacebookIntent(this.shareUrl);
    },
    lineUrl() {
      return createLineIntent({
        text: this.shareText,
        url: this.shareUrl
      });
    },
    resultTextArray() {
      return this.resultData.text.split("\n\n");
    },
    resultSrc() {
      return require(`@/assets/images/epilogue/${this.resultData.imgPath}`);
    },
    resultImageType() {
      return this.resultData.type;
    }
  },
  methods: {
    initSound() {
      audioApi.loadSound(AUDIO_SRC.YONIMO).then((sound) =>  {
        sound.play({ loop: true });
        this._soundYonimo = sound;
      });
    },
    showText(order) {
      this.textState = order;
    },
    animText(isHide = false, callback) {
      const timeline = new TimelineMax();
      timeline.to(this.$refs.text, 1.5, {
        opacity: 0,
        ease: Power1.easeOut
      });
      if (isHide) {
        timeline
          .fromTo(
            this.$refs.text,
            1.5,
            {
              opacity: 0
            },
            {
              opacity: 1,
              ease: Power1.easeIn
            }
          )
          .to(this.$refs.text, 1.5, {
            opacity: 0,
            delay: 1,
            ease: Power1.easeOut,
            onComplete: () => {
              setTimeout(callback, 500);
            }
          });
      } else {
        timeline.fromTo(
          this.$refs.text,
          1.5,
          {
            opacity: 0
          },
          {
            opacity: 1,
            ease: Power1.easeIn,
            onComplete: () => {
              setTimeout(callback, 1500);
            }
          }
        );
      }
    },
    shiftText() {
      if (this.resultTextArray.length > 1) {
        this.currentText = this.resultTextArray.shift();
        this.animText(true, this.shiftText.bind(this));
      } else if (this.resultTextArray.length === 1) {
        this.currentText = this.resultTextArray.shift();
        this.animText(false, this.shiftText.bind(this));
      } else {
        this.addAppearOrder();
      }
    },
    addAppearOrder() {
      this.appearOrder++;
    },
    sendShareEvent(sns) {
      gtag("event", "btn", {
        event_category: `result-${sns}`
      });
    },
    sendRestartEvent() {
      gtag("event", "goout", {
        event_category: "result-restart"
      });
    }
  },
  mounted() {
    if (!this.resultName || !this.userName) {
      this.$router.push({ name: "top" });
      return;
    }

    setTimeout(() => {
      this.addAppearOrder();
    }, 1000);
    this.initSound();
  },
  destroyed() {
    if (this._soundYonimo) this._soundYonimo.stop();
  },
  mixins: [commonConfig]
};
</script>
